export default __webpack_public_path__ + "static/media/Ppl.94de1fb9.jpg";